export const FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION = {
  validationErrorsNotificationProps: {
    requiredNotificationProps: {
      entityActionError: true,
    },
  },
  withNotifications: true,
}
